import RoleManagement from "./roles/RoleManagement";
import { useEffect } from "react";
import useBreadcrumbs from "@/hooks/store/useBreadcrumbs";
const ACL = () => {
  const { setRoutes } = useBreadcrumbs();
  useEffect(() => {
    setRoutes([
      {
        name: "Admins center",
        path: "/admins",
      },

      {
        name: "IT Admin roles",
        description:
          "Manage role templates that define access levels and permissions across your organization. Assign roles to control what each admin can view, edit, or manage within Trio.",
        helpLink:
          "https://help.trio.so/en/articles/12530422-organization-roles-in-trio-msp",
      },
    ]);
  }, []);
  return (
    <div className="h-full">
      <RoleManagement />
    </div>
  );
};

export default ACL;
